import React, { useEffect, useRef, useState } from "react";
import { List, Row, Tag, Col, Button, Spin, Checkbox } from "antd";
import _, { toUpper } from "lodash";
import { Box, Tooltip } from "@mui/material";
import { useDispatch } from "react-redux";
import FileDownloadDoneIcon from "@mui/icons-material/FileDownloadDone";
import PictureOutlined from "@ant-design/icons/es/icons/PictureOutlined";
import StarOutlined from "@ant-design/icons/es/icons/StarOutlined";
import StarFilled from "@ant-design/icons/es/icons/StarFilled";
import PlusOutlined from "@ant-design/icons/es/icons/PlusOutlined";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { searchCompaniesAction } from "../../actions/search.action";
import {
  getGmapStringAddress,
  translateRegistryOnView,
} from "../../libs/utils";
import Localize, { bareLocalize } from "../../libs/localization";
import { deleteAssociatedIdTagAction } from "../../actions/tag.actions";
import { openCompanyDetailAction } from "../../actions/company.actions";
import useListSelection from "../../hooks/useListSelection";
import ListLoader from "../ListLoader/ListLoader";

const CompanyList = (props) => {
  const {
    data: companyList,
    pageSize,
    setPageSize,
    title = "",
    onRowClick,
    total,
    filters = {},
    tagMode,
    setSelectedCompanies = () => {},
    isTagPage = false,
    loadingTag,
    loadingList,
    associatedTagsIds,
    setCompanyTagPage,
    resultsLimited = false,
    alreadyOpened = [],
    onTagRemove = () => {},
    page = 1,
    onPageChange,
    excludeIds = [],
    showAddButton = false,
  } = props;

  const [currentPage, setCurrentPage] = useState(1);
  const [selection, setSelection] = useState([]);
  const { deselectAll, toggle, addToSelection, removeFromSelection } =
    useListSelection({ selection, setSelection });
  const [selectAll, setSelectAll] = useState(false);

  const dispatch = useDispatch();

  const fetchData = (page, pageSize_) => {
    if (!isTagPage && !loadingList) {
      if (pageSize !== pageSize_) {
        setPageSize(pageSize_);
      }
      let params = {};

      params = {
        ...(filters || {}),
        pageNum: page,
        limit: pageSize_,
      };

      dispatch(
        searchCompaniesAction({
          data: params,
        }),
      );
    }
  };

  function openCompanyDetail(companyId) {
    dispatch(openCompanyDetailAction(companyId));
    // history.push(`/companies/${item._id}`)
  }

  const prevFilters = useRef();
  useEffect(() => {
    if (!prevFilters.current || !_.isEqual(prevFilters.current, filters)) {
      setCurrentPage(1);
    }
    prevFilters.current = filters;
  }, [filters]);

  useEffect(() => {
    setSelectedCompanies(selection);
  }, [selection]);

  useEffect(() => {
    deselectAll();
    setSelectAll(false);
  }, [tagMode]);

  const renderTag = (item) => {
    let renderedTags = [];
    if (associatedTagsIds)
      associatedTagsIds.map((association) => {
        const founded = association._id === item._id;
        if (founded) {
          renderedTags = association.tags.map((tag) => (
            <Tag
              key={tag.tagId}
              color={`#${tag.color}`}
              className="searchPage__item-tag"
              closable
              onClose={() => {
                dispatch(
                  deleteAssociatedIdTagAction(
                    {
                      tagId: tag.tagId,
                      associatedId: association._id,
                    },
                    () => onTagRemove(association._id),
                  ),
                );
              }}
            >
              {tag.name}
            </Tag>
          ));
        }
      });
    return renderedTags;
  };

  const renderStar = (item) => {
    const selected = selection.includes(item._id);
    const Component = selected ? StarFilled : StarOutlined;
    return <Component style={{ fontSize: 20 }} />;
  };

  return (
    <>
      {loadingList ? (
        <ListLoader />
      ) : (
        <div title={title}>
          {tagMode && (
            <Checkbox
              checked={selectAll}
              onChange={(e) => {
                setSelectAll(e.target.checked);
                const ids = companyList.map((company) => company._id);
                if (e.target.checked) {
                  addToSelection(ids);
                } else {
                  removeFromSelection(ids);
                }
              }}
            >
              {Localize("COMMON.SELECT_ALL")}
            </Checkbox>
          )}
          <List
            className="searchPage__list animation"
            itemLayout="horizontal"
            dataSource={companyList}
            pagination={
              resultsLimited
                ? false
                : {
                    onChange: (page, pageSize_) => {
                      setSelectAll(false);
                      setCurrentPage(page);
                      if (onPageChange) {
                        onPageChange(page, pageSize_);
                      } else {
                        setPageSize(pageSize_);
                        if (setCompanyTagPage) setCompanyTagPage(page);
                        fetchData(page, pageSize_);
                      }
                      console.log("set page size", page, pageSize_);
                    },
                    current: page || currentPage,
                    pageSize,
                    total,
                    showSizeChanger: !isTagPage,
                  }
            }
            renderItem={(item) => {
              const isExcluded = excludeIds.includes(item._id);
              const actions = [];
              if (showAddButton && !isExcluded) {
                actions.push(
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    size="middle"
                    style={{
                      fontWeight: 600,
                      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                      display: "flex",
                      alignItems: "center",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (onRowClick) onRowClick(item);
                    }}
                  >
                    {Localize("PAGES.DASHBOARD.ADD_TO_COMPARISON")}
                  </Button>,
                );
              }

              const row = (
                <div
                  className={`searchPage__item-more animation fadein-right slow ${
                    isExcluded ? "excluded-company" : ""
                  }`}
                  style={
                    isExcluded ? { opacity: 0.5, filter: "grayscale(1)" } : {}
                  }
                >
                  <List.Item
                    className="searchPage__item"
                    actions={actions}
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" && e.target === e.currentTarget) {
                        e.currentTarget.click();
                      }
                    }}
                    onClick={(e) => {
                      if (isExcluded) return;
                      if (!(e.ctrlKey || e.metaKey)) {
                        e.preventDefault();
                        e.stopPropagation();
                        if (typeof onRowClick === "function") {
                          onRowClick(item);
                        } else {
                          !tagMode && openCompanyDetail(item._id);
                        }
                      }
                    }}
                  >
                    <List.Item.Meta
                      avatar={
                        item.logo ? (
                          <div
                            style={{ backgroundImage: `url("${item.logo}")` }}
                            className="searchPage__item-logo"
                          />
                        ) : (
                          <div className="searchPage__item-logo searchPage__item-logo--placeholder">
                            <PictureOutlined />
                          </div>
                        )
                      }
                      title={
                        <Row align="middle" justify="space-between">
                          <Col>
                            <h3 className="searchPage__item-title">
                              {tagMode && (
                                <Button
                                  type="text"
                                  shape="circle"
                                  size="small"
                                  className="mr-2"
                                  onClick={() => {
                                    toggle(item._id);
                                  }}
                                >
                                  {renderStar(item)}
                                </Button>
                              )}
                              <b className="mr-2">{toUpper(item.name)}</b>
                              {loadingTag ? (
                                <Spin size="small" className="ml-4" />
                              ) : (
                                renderTag(item)
                              )}
                            </h3>
                          </Col>
                          <Box sx={{ marginRight: 2 }}>
                            {alreadyOpened?.includes(item._id) ? (
                              <Tooltip
                                title={bareLocalize(
                                  "COMPANY_LIST.ALREADY_OPENED.TOOLTIP",
                                )}
                              >
                                <FileDownloadDoneIcon />
                              </Tooltip>
                            ) : null}
                          </Box>
                        </Row>
                      }
                      description={
                        <>
                          <p>{getGmapStringAddress(item)}</p>
                          <p>
                            {item.sector &&
                              item.sector.map((s, i) => (
                                <Tag key={i}>
                                  {" "}
                                  {translateRegistryOnView(s._id, "Sector")
                                    ? translateRegistryOnView(s._id, "Sector")
                                    : s.key}{" "}
                                </Tag>
                              ))}
                          </p>
                        </>
                      }
                    />
                  </List.Item>
                </div>
              );
              if (!tagMode && !isTagPage && !onRowClick && !isExcluded)
                return (
                  <Link
                    to={`/companies/${item._id}`}
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    {row}
                  </Link>
                );
              return row;
            }}
          />
        </div>
      )}
    </>
  );
};

export default CompanyList;
